// extracted by mini-css-extract-plugin
export var lbContainerOuter = "D_vm";
export var lbContainerInner = "D_vn";
export var movingForwards = "D_vp";
export var movingForwardsOther = "D_vq";
export var movingBackwards = "D_vr";
export var movingBackwardsOther = "D_vs";
export var lbImage = "D_vt";
export var lbOtherImage = "D_vv";
export var prevButton = "D_vw";
export var nextButton = "D_vx";
export var closing = "D_vy";
export var appear = "D_vz";